import React from "react";
import { isMobileView } from "../../../lib/utils";
import PrizeList from "../general/PrizeList";
import RaffleDonateLink from "./RaffleDonateLink";

export default class RaffleClosed extends React.PureComponent {
  state = { openFaqs: [] };

  render() {
    const {
      isPastResultsPosting,
      raffle: { drawingDate, resultsPostingDate, gregorianYear, hebrewYear },
      raffleEnrollment,
      raffleEnrollment: { prizes, campaignLogoUrl },
      raffleWinners,
      sellerId,
    } = this.props;

    const { openFaqs } = this.state;

    return (
      <>
        <header className="header header-tint-dark">
          <div className="background">
            {isMobileView() ? (
              <img
                src="/images/mobile-background.jpg"
                alt="background"
                style={{ height: "100%", width: "100%", objectFit: "cover" }}
              />
            ) : (
              <>
                <video
                  autoplay="autoplay"
                  muted="true"
                  loop
                  id="myVideo"
                  preload="true"
                >
                  <source src="/images/bg-flow.mp4" type="video/mp4" />
                  Your browser does not support HTML5 video.
                </video>
                <div className="video-overlay video-overlay-dark" />
                <div className="background-text">
                  Keep them
                  <br />
                  Growing.
                  <br />
                  proud.
                  <br />
                  wrapping.
                  <br />
                  Lighting.
                  <br />
                  giving.
                  <br />
                  Learning.
                </div>
              </>
            )}
          </div>
          <div className="header-title">
            {!!sellerId ? (
              <p className="fs-20 fw-900 text-center uppercase-text">
                {raffleEnrollment?.chabadHouseName}
              </p>
            ) : (
              <p className="fs-20 fw-900 text-center uppercase-text">
                Chabad on Campus
              </p>
            )}
            <p className="bh">ב״ה</p>
          </div>
          <div className="header-logo">
            <img src={campaignLogoUrl || "/images/logo.png"} alt="logo" />
            <p
              className="fs-50 fw-900 light-text mt-8"
              style={{ textShadow: "0 0 4px rgba(0, 0, 0, 0.25)" }}
            >
              {`${gregorianYear}/${hebrewYear}`}
            </p>
          </div>
          <div className="mt-40 mobile-mt-48">
            <p
              className="fs-45 fw-800 accent-color-text text-center mb-16"
              style={{
                lineHeight: "40px",
                textShadow: "0px 2px 4px rgba(0, 0, 0, 0.3)",
              }}
            >
              The Grand Draw is now closed.
            </p>
            <RaffleDonateLink
              raffleEnrollment={raffleEnrollment}
              sellerId={sellerId}
            />
          </div>
          {isPastResultsPosting ? (
            <div className="mt-24">
              <PrizeList prizes={prizes} winners={raffleWinners} />
            </div>
          ) : (
            <div className="faqs">
              {[
                {
                  q: "When will the grand draw be drawn?",
                  a:
                    (drawingDate ? `${drawingDate} ET.` : "To be announced.") +
                    (resultsPostingDate
                      ? ` \nResults will be posted here on ${resultsPostingDate} ET for a minimum of thirty days.`
                      : ""),
                },
                {
                  q: "How will I be notified if I win?",
                  a: `The winners of the Grand Draw drawing will be notified via phone, email and/or postal mail. 
                      All prizes must be claimed within one (1) month of notification or prize may be forfeited.`,
                },
              ].map((question, index) => {
                const isOpen = openFaqs.includes(index);
                return (
                  <div className="faq-card" key={index}>
                    <div className="fs-22 fw-600 flex flex-justify-space">
                      <p>{question.q}</p>
                      <i
                        className="material-icons pointer ml-24"
                        onClick={() =>
                          this.setState({
                            openFaqs: isOpen
                              ? openFaqs.filter((f) => f !== index)
                              : [...openFaqs, index],
                          })
                        }
                      >
                        {isOpen ? "remove" : "add"}
                      </i>
                    </div>
                    {isOpen && (
                      <p className="fs-18 line-height-double mt-16">
                        {question.a}
                      </p>
                    )}
                  </div>
                );
              })}
            </div>
          )}
        </header>
      </>
    );
  }
}
